// extracted by mini-css-extract-plugin
export default {"main":"StopMainSection_main__0vsjN"};